import environment from "environment";
import EffectUtility from "../../utilities/EffectUtility";

import StatusModel from "./model/StatusModel";

// StatusEffect
export default class StatusEffect {
  // calling an API according to the status model
  // Get method for the
  static async requestStatus(params) {
    const endpoint = environment.api.status;
    return EffectUtility.getToModel(StatusModel, endpoint, params);
  }

  // Get method for the status filter
  static async requestStatusFilter(params) {
    const endpoint = environment.api.statusFilter;
    return EffectUtility.getToModel(StatusModel, endpoint, params);
  }
}
